import _ from "lodash";
import { useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useUpdateMultipleHoldersBalance = () => {
  const [message, setMessage] = useState("");
  const [waitUpdateMultipleHolders, setWaitUpdateMultipleHolders] =
    useState(false);
  const tokenAddress = localStorage.getItem("tokenContractAddress");

  const callUpdateMultipleHolders = async (
    signer: ethers.ContractRunner | null | undefined,
    holders: string[],
    amount: any[],
    externalIds: string[]
  ) => {
    try {
  

      const amountAsStrings = amount.map((amt) => amt.toString());
     
      setWaitUpdateMultipleHolders(true);

      const callAbi = new ethers.Contract(
        tokenAddress || "",
        ERC20ABI.abi,
        signer
      );

      const tx = await callAbi.updateMultipleHolders(holders, amountAsStrings, externalIds);

      setWaitUpdateMultipleHolders(false);
      return { err: "", tx: tx };
    } catch (err: any) {
      const errs = _.get(err, "error.message");
      const msgs = _.get("", errs);
      if (err.code === "ACTION_REJECTED") {
        setWaitUpdateMultipleHolders(false);
        setMessage("User rejected transaction");
        return { err: "User rejected transaction", tx: "" };
      } else {
        if (msgs === undefined) {
          setWaitUpdateMultipleHolders(false);
          setMessage((/missing revert data/).test(err.message.split("(")[0]) ? "Invalid data, please ensure the holders in the file are new." : err.message.split("(")[0] || "");
          return { err: (/missing revert data/).test(err.message.split("(")[0]) ? "Invalid data, please ensure the holders in the file are new." : err.message.split("(")[0] || "", tx: "" };
        } else {
          setWaitUpdateMultipleHolders(false);
          setMessage(msgs.msg);
          return { err: msgs.msg, tx: "" };
        }
      }
    }
  };

  return {
    onUpdateMultipleHolders: callUpdateMultipleHolders,
    waitUpdateMultipleHolders: waitUpdateMultipleHolders,
    messageUpdateMultipleError: message,
  };
};
